"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  // originalOwner: 'validateIsNotEmpty',
  // vehiclePurchase: 'validateIsNotEmpty',
  // vehicleCondition: 'validateIsNotEmpty',
  // corporateUse: 'validateIsNotEmpty',
  corporateUseExplanation: 'validateIsNotEmpty',
  // rustProof: 'validateIsNotEmpty',
  // mechanicalProtection: 'validateIsNotEmpty',
  coverageBalance: 'validateIsNotEmpty',
  // hadAnAccident: 'validateIsNotEmpty',
  needReparationOtherExplanation: 'validateIsNotEmpty',
  clarifyDamage: 'validateIsNotEmpty',
  // airBagsOperational: 'validateIsNotEmpty',
  // modifiedParts: 'validateIsNotEmpty',
  // partsToReplace: 'validateIsNotEmpty',
  // replacedTires: 'validateIsNotEmpty',
  // replacedBrakes: 'validateIsNotEmpty',
  // anyScratches: 'validateIsNotEmpty',
  // damageExceeding3000: 'validateIsNotEmpty',
  // majorExteriorInteriorDamage: 'validateIsNotEmpty',
  clarifyAccident: 'validateIsNotEmpty',
  // bodyPartReplaced: 'validateIsNotEmpty',
  // absOperational: 'validateIsNotEmpty',
  clarifyRegistry: 'validateIsNotEmpty',
  clarifyOpenNotices: 'validateIsNotEmpty',
  trueDistanceTraveled: 'validateIsNotEmpty'
};
exports.default = _default;